import SuccessAnimation from "@/assets/success.json";

/** Green fills in `success.json` — swapped for brand `primary_color` (Lottie has no theme API). */
const DEFAULT_GREEN_RGBA = /\[0\.059,0\.843,0\.565,1\]/g;

/**
 * Returns a copy of the success checkmark Lottie JSON with fill color replaced by `primaryColor`.
 * Invalid hex falls back to the asset default (green).
 */
export function getBrandedSuccessAnimationData(
	primaryColor: string,
): typeof SuccessAnimation {
	const m = /^#?([0-9a-f]{6})$/i.exec(primaryColor.trim());
	if (!m) return SuccessAnimation;
	const h = m[1];
	const r = Number.parseInt(h.slice(0, 2), 16) / 255;
	const g = Number.parseInt(h.slice(2, 4), 16) / 255;
	const b = Number.parseInt(h.slice(4, 6), 16) / 255;
	return JSON.parse(
		JSON.stringify(SuccessAnimation).replace(
			DEFAULT_GREEN_RGBA,
			`[${r},${g},${b},1]`,
		),
	) as typeof SuccessAnimation;
}
